import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { COLORS, MQS } from '../constants/styles';

interface IProps {
    open: boolean;
}

export interface IAccordionProps {
    isOpen: boolean;
    children?: ReactNode;
}

const AccordionWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: ${COLORS.grey2};
    border-radius: 10px;
    height: auto;
    padding: 2%;
    text-align: center;
    transition: all 0.6s ease-in-out;
    @media (min-width: ${MQS.mq2Min}) {
        display: none;
    }
`;

const InternalWrapper = styled.div`
    width: 100%;
    max-height: ${(props: IProps) => (props.open ? '100%' : '0')};
    transition: all 1s ease-in-out;
    overflow: hidden;
`;

const Content = styled.div`
    padding: 5px;
`;

export const Accordion = ({ isOpen, children }: IAccordionProps) => {
    return (
        <AccordionWrapper>
            <InternalWrapper open={isOpen}>
                <Content>{children}</Content>
            </InternalWrapper>
        </AccordionWrapper>
    );
};

export default Accordion;
